module.exports = __webpack_public_path__ + "img/eoy-giving-donate-6.033e0ddc.jpg";